import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _609ab9a7 = () => interopDefault(import('../pages/banners/index.vue' /* webpackChunkName: "pages/banners/index" */))
const _4b00f89f = () => interopDefault(import('../pages/bol-screenshots/index.vue' /* webpackChunkName: "pages/bol-screenshots/index" */))
const _7d18eae2 = () => interopDefault(import('../pages/card-orders/index.vue' /* webpackChunkName: "pages/card-orders/index" */))
const _d866f6fa = () => interopDefault(import('../pages/cards/index.vue' /* webpackChunkName: "pages/cards/index" */))
const _06d27c00 = () => interopDefault(import('../pages/cashback-setup/index.vue' /* webpackChunkName: "pages/cashback-setup/index" */))
const _66eaf0ea = () => interopDefault(import('../pages/cashback-setup/index/legal.vue' /* webpackChunkName: "pages/cashback-setup/index/legal" */))
const _1c7ec718 = () => interopDefault(import('../pages/cashback-setup/index/private.vue' /* webpackChunkName: "pages/cashback-setup/index/private" */))
const _f41342b4 = () => interopDefault(import('../pages/client-requests/index.vue' /* webpackChunkName: "pages/client-requests/index" */))
const _545625be = () => interopDefault(import('../pages/country-groups/index.vue' /* webpackChunkName: "pages/country-groups/index" */))
const _ebafe82c = () => interopDefault(import('../pages/country-groups/index/_categoryId.vue' /* webpackChunkName: "pages/country-groups/index/_categoryId" */))
const _3e132d80 = () => interopDefault(import('../pages/custom-requests/index.vue' /* webpackChunkName: "pages/custom-requests/index" */))
const _349327b7 = () => interopDefault(import('../pages/czcb-swifts/index.vue' /* webpackChunkName: "pages/czcb-swifts/index" */))
const _528ad818 = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _3a9e93ba = () => interopDefault(import('../pages/fees/index.vue' /* webpackChunkName: "pages/fees/index" */))
const _1e2d40f1 = () => interopDefault(import('../pages/fees/index/recurring.vue' /* webpackChunkName: "pages/fees/index/recurring" */))
const _6fb55d9d = () => interopDefault(import('../pages/fees/index/transactional.vue' /* webpackChunkName: "pages/fees/index/transactional" */))
const _768f1af0 = () => interopDefault(import('../pages/fin-channels/index.vue' /* webpackChunkName: "pages/fin-channels/index" */))
const _f3ec882a = () => interopDefault(import('../pages/forex-requests/index.vue' /* webpackChunkName: "pages/forex-requests/index" */))
const _1a45aacc = () => interopDefault(import('../pages/forex-setup/index.vue' /* webpackChunkName: "pages/forex-setup/index" */))
const _3c05ed2a = () => interopDefault(import('../pages/forex-setup/index/limits.vue' /* webpackChunkName: "pages/forex-setup/index/limits" */))
const _219072e0 = () => interopDefault(import('../pages/forex-setup/index/rates.vue' /* webpackChunkName: "pages/forex-setup/index/rates" */))
const _27b15386 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _e2398a70 = () => interopDefault(import('../pages/notifications/index.vue' /* webpackChunkName: "pages/notifications/index" */))
const _7fec6882 = () => interopDefault(import('../pages/payment-orders/index.vue' /* webpackChunkName: "pages/payment-orders/index" */))
const _23f6ba23 = () => interopDefault(import('../pages/payments/index.vue' /* webpackChunkName: "pages/payments/index" */))
const _87411e9a = () => interopDefault(import('../pages/rates/index.vue' /* webpackChunkName: "pages/rates/index" */))
const _54d814e9 = () => interopDefault(import('../pages/referral-campaigns/index.vue' /* webpackChunkName: "pages/referral-campaigns/index" */))
const _398a2f56 = () => interopDefault(import('../pages/referrals/index.vue' /* webpackChunkName: "pages/referrals/index" */))
const _1b530509 = () => interopDefault(import('../pages/savings-setup/index.vue' /* webpackChunkName: "pages/savings-setup/index" */))
const _014ea7ea = () => interopDefault(import('../pages/savings-setup/index/deposits.vue' /* webpackChunkName: "pages/savings-setup/index/deposits" */))
const _6f23bb13 = () => interopDefault(import('../pages/savings-setup/index/savings-account.vue' /* webpackChunkName: "pages/savings-setup/index/savings-account" */))
const _25965b03 = () => interopDefault(import('../pages/subscription-setup/index.vue' /* webpackChunkName: "pages/subscription-setup/index" */))
const _5070e2db = () => interopDefault(import('../pages/swift-message-orders/index.vue' /* webpackChunkName: "pages/swift-message-orders/index" */))
const _66982b3c = () => interopDefault(import('../pages/swift-messages/index.vue' /* webpackChunkName: "pages/swift-messages/index" */))
const _145cf63c = () => interopDefault(import('../pages/target2-participants/index.vue' /* webpackChunkName: "pages/target2-participants/index" */))
const _15e1e0e8 = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _3c65c369 = () => interopDefault(import('../pages/working-days/index.vue' /* webpackChunkName: "pages/working-days/index" */))
const _4b1e7412 = () => interopDefault(import('../pages/banners/create.vue' /* webpackChunkName: "pages/banners/create" */))
const _4db8bc1c = () => interopDefault(import('../pages/card-orders/create.vue' /* webpackChunkName: "pages/card-orders/create" */))
const _6089c0d8 = () => interopDefault(import('../pages/client-requests/create.vue' /* webpackChunkName: "pages/client-requests/create" */))
const _256c7c6c = () => interopDefault(import('../pages/czcb-swifts/upload.vue' /* webpackChunkName: "pages/czcb-swifts/upload" */))
const _766a0216 = () => interopDefault(import('../pages/fees/groups/index.vue' /* webpackChunkName: "pages/fees/groups/index" */))
const _151ecb7b = () => interopDefault(import('../pages/notifications/upload.vue' /* webpackChunkName: "pages/notifications/upload" */))
const _4e0067a8 = () => interopDefault(import('../pages/open-banking/applications.vue' /* webpackChunkName: "pages/open-banking/applications" */))
const _44762cc4 = () => interopDefault(import('../pages/open-banking/institutions.vue' /* webpackChunkName: "pages/open-banking/institutions" */))
const _187bc1b6 = () => interopDefault(import('../pages/open-banking/payments.vue' /* webpackChunkName: "pages/open-banking/payments" */))
const _39de42ed = () => interopDefault(import('../pages/payments/errors/index.vue' /* webpackChunkName: "pages/payments/errors/index" */))
const _61afc213 = () => interopDefault(import('../pages/payments/not-settled/index.vue' /* webpackChunkName: "pages/payments/not-settled/index" */))
const _e31164fe = () => interopDefault(import('../pages/payments/on-hold/index.vue' /* webpackChunkName: "pages/payments/on-hold/index" */))
const _7b67fb0e = () => interopDefault(import('../pages/payments/on-hold-integrator/index.vue' /* webpackChunkName: "pages/payments/on-hold-integrator/index" */))
const _713e6eab = () => interopDefault(import('../pages/payments/pending/index.vue' /* webpackChunkName: "pages/payments/pending/index" */))
const _67c77b3b = () => interopDefault(import('../pages/payments/pending-cancellation/index.vue' /* webpackChunkName: "pages/payments/pending-cancellation/index" */))
const _2a7f45e8 = () => interopDefault(import('../pages/payments/postponed-swift/index.vue' /* webpackChunkName: "pages/payments/postponed-swift/index" */))
const _5ba81069 = () => interopDefault(import('../pages/payments/unassigned/index.vue' /* webpackChunkName: "pages/payments/unassigned/index" */))
const _566395e0 = () => interopDefault(import('../pages/payments/unidentified-topups/index.vue' /* webpackChunkName: "pages/payments/unidentified-topups/index" */))
const _5c76d746 = () => interopDefault(import('../pages/payments/verification/index.vue' /* webpackChunkName: "pages/payments/verification/index" */))
const _0044978d = () => interopDefault(import('../pages/profile-customers/create.vue' /* webpackChunkName: "pages/profile-customers/create" */))
const _2d54edb6 = () => interopDefault(import('../pages/profile-customers/import.vue' /* webpackChunkName: "pages/profile-customers/import" */))
const _1ead3d07 = () => interopDefault(import('../pages/profiles/legal.vue' /* webpackChunkName: "pages/profiles/legal" */))
const _7bbf555e = () => interopDefault(import('../pages/profiles/private.vue' /* webpackChunkName: "pages/profiles/private" */))
const _fe024680 = () => interopDefault(import('../pages/profiles/remittance.vue' /* webpackChunkName: "pages/profiles/remittance" */))
const _6dded2f5 = () => interopDefault(import('../pages/referral-campaigns/create.vue' /* webpackChunkName: "pages/referral-campaigns/create" */))
const _3540797a = () => interopDefault(import('../pages/swift-message-orders/create.vue' /* webpackChunkName: "pages/swift-message-orders/create" */))
const _e80c76be = () => interopDefault(import('../pages/target2-participants/upload.vue' /* webpackChunkName: "pages/target2-participants/upload" */))
const _faea382a = () => interopDefault(import('../pages/fees/groups/create/index.vue' /* webpackChunkName: "pages/fees/groups/create/index" */))
const _42457b70 = () => interopDefault(import('../pages/fees/recurring/create/index.vue' /* webpackChunkName: "pages/fees/recurring/create/index" */))
const _a026a678 = () => interopDefault(import('../pages/fees/transactional/create/index.vue' /* webpackChunkName: "pages/fees/transactional/create/index" */))
const _3c99ec16 = () => interopDefault(import('../pages/payments/create/fee/index.vue' /* webpackChunkName: "pages/payments/create/fee/index" */))
const _3350f92b = () => interopDefault(import('../pages/payments/create/forex/index.vue' /* webpackChunkName: "pages/payments/create/forex/index" */))
const _368b8344 = () => interopDefault(import('../pages/payments/create/internal/index.vue' /* webpackChunkName: "pages/payments/create/internal/index" */))
const _143f7b9f = () => interopDefault(import('../pages/payments/create/topup/index.vue' /* webpackChunkName: "pages/payments/create/topup/index" */))
const _d68f2f88 = () => interopDefault(import('../pages/payments/create/withdrawal/index.vue' /* webpackChunkName: "pages/payments/create/withdrawal/index" */))
const _64c46fef = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3cb6d7d8 = () => interopDefault(import('../pages/channel-setup/channel-route/_channelRouteId/index.vue' /* webpackChunkName: "pages/channel-setup/channel-route/_channelRouteId/index" */))
const _74afbbfe = () => interopDefault(import('../pages/fees/groups/_id/index.vue' /* webpackChunkName: "pages/fees/groups/_id/index" */))
const _e57adcb6 = () => interopDefault(import('../pages/fees/recurring/_recurringFeeId/index.vue' /* webpackChunkName: "pages/fees/recurring/_recurringFeeId/index" */))
const _c32067a0 = () => interopDefault(import('../pages/fees/transactional/_transactionFeeId/index.vue' /* webpackChunkName: "pages/fees/transactional/_transactionFeeId/index" */))
const _0d6abcb8 = () => interopDefault(import('../pages/channel-setup/channel-route/_channelRouteId/edit.vue' /* webpackChunkName: "pages/channel-setup/channel-route/_channelRouteId/edit" */))
const _4a1185aa = () => interopDefault(import('../pages/fees/groups/_id/edit.vue' /* webpackChunkName: "pages/fees/groups/_id/edit" */))
const _7a88a36c = () => interopDefault(import('../pages/fees/recurring/_recurringFeeId/edit/index.vue' /* webpackChunkName: "pages/fees/recurring/_recurringFeeId/edit/index" */))
const _4bf4529f = () => interopDefault(import('../pages/fees/transactional/_transactionFeeId/edit/index.vue' /* webpackChunkName: "pages/fees/transactional/_transactionFeeId/edit/index" */))
const _6d11e626 = () => interopDefault(import('../pages/card-orders/_orderId/index.vue' /* webpackChunkName: "pages/card-orders/_orderId/index" */))
const _6d59ced4 = () => interopDefault(import('../pages/channel-setup/_license/index.vue' /* webpackChunkName: "pages/channel-setup/_license/index" */))
const _b428f6c2 = () => interopDefault(import('../pages/client-requests/_clientRequestId/index.vue' /* webpackChunkName: "pages/client-requests/_clientRequestId/index" */))
const _cc2d8960 = () => interopDefault(import('../pages/custom-requests/_requestId/index.vue' /* webpackChunkName: "pages/custom-requests/_requestId/index" */))
const _1dcaae1e = () => interopDefault(import('../pages/deposits/_depositId.vue' /* webpackChunkName: "pages/deposits/_depositId" */))
const _e247ae16 = () => interopDefault(import('../pages/payment-orders/_paymentOrderId/index.vue' /* webpackChunkName: "pages/payment-orders/_paymentOrderId/index" */))
const _4d0e3c7e = () => interopDefault(import('../pages/payments/_paymentId.vue' /* webpackChunkName: "pages/payments/_paymentId" */))
const _5b7886cd = () => interopDefault(import('../pages/payments/_paymentId/activity.vue' /* webpackChunkName: "pages/payments/_paymentId/activity" */))
const _44a75a1a = () => interopDefault(import('../pages/payments/_paymentId/general.vue' /* webpackChunkName: "pages/payments/_paymentId/general" */))
const _4df1b8ac = () => interopDefault(import('../pages/payments/_paymentId/operations.vue' /* webpackChunkName: "pages/payments/_paymentId/operations" */))
const _11728e8c = () => interopDefault(import('../pages/profile-customers/_customerId/index.vue' /* webpackChunkName: "pages/profile-customers/_customerId/index" */))
const _543264c7 = () => interopDefault(import('../pages/profiles/_profileId.vue' /* webpackChunkName: "pages/profiles/_profileId" */))
const _107e8fde = () => interopDefault(import('../pages/profiles/_profileId/accounts.vue' /* webpackChunkName: "pages/profiles/_profileId/accounts" */))
const _2f7b0a87 = () => interopDefault(import('../pages/profiles/_profileId/activity.vue' /* webpackChunkName: "pages/profiles/_profileId/activity" */))
const _38db217a = () => interopDefault(import('../pages/profiles/_profileId/card-orders.vue' /* webpackChunkName: "pages/profiles/_profileId/card-orders" */))
const _76f25f2b = () => interopDefault(import('../pages/profiles/_profileId/card-topup.vue' /* webpackChunkName: "pages/profiles/_profileId/card-topup" */))
const _2b2e081b = () => interopDefault(import('../pages/profiles/_profileId/cards.vue' /* webpackChunkName: "pages/profiles/_profileId/cards" */))
const _ac13eedc = () => interopDefault(import('../pages/profiles/_profileId/cashback.vue' /* webpackChunkName: "pages/profiles/_profileId/cashback" */))
const _fce1f7e6 = () => interopDefault(import('../pages/profiles/_profileId/customers.vue' /* webpackChunkName: "pages/profiles/_profileId/customers" */))
const _e28cb8fa = () => interopDefault(import('../pages/profiles/_profileId/esim-reissue.vue' /* webpackChunkName: "pages/profiles/_profileId/esim-reissue" */))
const _1783b4b5 = () => interopDefault(import('../pages/profiles/_profileId/features.vue' /* webpackChunkName: "pages/profiles/_profileId/features" */))
const _4179ae25 = () => interopDefault(import('../pages/profiles/_profileId/fees.vue' /* webpackChunkName: "pages/profiles/_profileId/fees" */))
const _66e898e4 = () => interopDefault(import('../pages/profiles/_profileId/forex-setup.vue' /* webpackChunkName: "pages/profiles/_profileId/forex-setup" */))
const _21edb51b = () => interopDefault(import('../pages/profiles/_profileId/open-banking.vue' /* webpackChunkName: "pages/profiles/_profileId/open-banking" */))
const _0af7b184 = () => interopDefault(import('../pages/profiles/_profileId/payment-orders.vue' /* webpackChunkName: "pages/profiles/_profileId/payment-orders" */))
const _9c5c30b6 = () => interopDefault(import('../pages/profiles/_profileId/payments.vue' /* webpackChunkName: "pages/profiles/_profileId/payments" */))
const _1d1f14bc = () => interopDefault(import('../pages/profiles/_profileId/requests.vue' /* webpackChunkName: "pages/profiles/_profileId/requests" */))
const _5df5fcc2 = () => interopDefault(import('../pages/profiles/_profileId/restrictions.vue' /* webpackChunkName: "pages/profiles/_profileId/restrictions" */))
const _170a0a71 = () => interopDefault(import('../pages/profiles/_profileId/savings.vue' /* webpackChunkName: "pages/profiles/_profileId/savings" */))
const _2381acca = () => interopDefault(import('../pages/profiles/_profileId/settings.vue' /* webpackChunkName: "pages/profiles/_profileId/settings" */))
const _4e05d440 = () => interopDefault(import('../pages/profiles/_profileId/users.vue' /* webpackChunkName: "pages/profiles/_profileId/users" */))
const _7505c285 = () => interopDefault(import('../pages/profiles/_profileId/watchdog.vue' /* webpackChunkName: "pages/profiles/_profileId/watchdog" */))
const _539a1284 = () => interopDefault(import('../pages/referral-campaigns/_campaignId/index.vue' /* webpackChunkName: "pages/referral-campaigns/_campaignId/index" */))
const _5abe082c = () => interopDefault(import('../pages/savings-accounts/_savingsAccountId.vue' /* webpackChunkName: "pages/savings-accounts/_savingsAccountId" */))
const _5bfe34f6 = () => interopDefault(import('../pages/savings-accounts/_savingsAccountId/general.vue' /* webpackChunkName: "pages/savings-accounts/_savingsAccountId/general" */))
const _d936b2f0 = () => interopDefault(import('../pages/savings-accounts/_savingsAccountId/transactions.vue' /* webpackChunkName: "pages/savings-accounts/_savingsAccountId/transactions" */))
const _30e48600 = () => interopDefault(import('../pages/swift-message-orders/_swiftMessageOrderId/index.vue' /* webpackChunkName: "pages/swift-message-orders/_swiftMessageOrderId/index" */))
const _2a3e6e07 = () => interopDefault(import('../pages/swift-messages/_messageCloudReference/index.vue' /* webpackChunkName: "pages/swift-messages/_messageCloudReference/index" */))
const _fa7f6ba4 = () => interopDefault(import('../pages/banners/_bannerId/edit.vue' /* webpackChunkName: "pages/banners/_bannerId/edit" */))
const _75234276 = () => interopDefault(import('../pages/card-orders/_orderId/card.vue' /* webpackChunkName: "pages/card-orders/_orderId/card" */))
const _7ef5236e = () => interopDefault(import('../pages/card-orders/_orderId/card/activity.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/activity" */))
const _6a800664 = () => interopDefault(import('../pages/card-orders/_orderId/card/data.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/data" */))
const _efd4c6a4 = () => interopDefault(import('../pages/card-orders/_orderId/card/delivery.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/delivery" */))
const _56399b52 = () => interopDefault(import('../pages/card-orders/_orderId/card/limits.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/limits" */))
const _256944bf = () => interopDefault(import('../pages/card-orders/_orderId/edit.vue' /* webpackChunkName: "pages/card-orders/_orderId/edit" */))
const _6594566a = () => interopDefault(import('../pages/channel-setup/_license/create.vue' /* webpackChunkName: "pages/channel-setup/_license/create" */))
const _db83295c = () => interopDefault(import('../pages/profile-customers/_customerId/edit.vue' /* webpackChunkName: "pages/profile-customers/_customerId/edit" */))
const _7a08726d = () => interopDefault(import('../pages/profile-customers/_customerId/view.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view" */))
const _178299a0 = () => interopDefault(import('../pages/profile-customers/_customerId/view/index.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view/index" */))
const _5cc2f7a1 = () => interopDefault(import('../pages/profile-customers/_customerId/view/activity.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view/activity" */))
const _02a17ec6 = () => interopDefault(import('../pages/profile-customers/_customerId/view/general.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view/general" */))
const _0093b048 = () => interopDefault(import('../pages/referral-campaigns/_campaignId/edit.vue' /* webpackChunkName: "pages/referral-campaigns/_campaignId/edit" */))
const _1d249953 = () => interopDefault(import('../pages/swift-messages/_swiftMessageId/reply.vue' /* webpackChunkName: "pages/swift-messages/_swiftMessageId/reply" */))
const _a67297b4 = () => interopDefault(import('../pages/swift-messages/_swiftMessageId/v2/index.vue' /* webpackChunkName: "pages/swift-messages/_swiftMessageId/v2/index" */))
const _97aaa716 = () => interopDefault(import('../pages/channel-setup/_license/_currency/index.vue' /* webpackChunkName: "pages/channel-setup/_license/_currency/index" */))
const _a264f2ce = () => interopDefault(import('../pages/channel-setup/_license/_currency/index/activity.vue' /* webpackChunkName: "pages/channel-setup/_license/_currency/index/activity" */))
const _6d91a5ad = () => interopDefault(import('../pages/channel-setup/_license/_currency/index/settings.vue' /* webpackChunkName: "pages/channel-setup/_license/_currency/index/settings" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/banners",
    component: _609ab9a7,
    name: "banners"
  }, {
    path: "/bol-screenshots",
    component: _4b00f89f,
    name: "bol-screenshots"
  }, {
    path: "/card-orders",
    component: _7d18eae2,
    name: "card-orders"
  }, {
    path: "/cards",
    component: _d866f6fa,
    name: "cards"
  }, {
    path: "/cashback-setup",
    component: _06d27c00,
    name: "cashback-setup",
    children: [{
      path: "legal",
      component: _66eaf0ea,
      name: "cashback-setup-index-legal"
    }, {
      path: "private",
      component: _1c7ec718,
      name: "cashback-setup-index-private"
    }]
  }, {
    path: "/client-requests",
    component: _f41342b4,
    name: "client-requests"
  }, {
    path: "/country-groups",
    component: _545625be,
    name: "country-groups",
    children: [{
      path: ":categoryId?",
      component: _ebafe82c,
      name: "country-groups-index-categoryId"
    }]
  }, {
    path: "/custom-requests",
    component: _3e132d80,
    name: "custom-requests"
  }, {
    path: "/czcb-swifts",
    component: _349327b7,
    name: "czcb-swifts"
  }, {
    path: "/dashboard",
    component: _528ad818,
    name: "dashboard"
  }, {
    path: "/fees",
    component: _3a9e93ba,
    name: "fees",
    children: [{
      path: "recurring",
      component: _1e2d40f1,
      name: "fees-index-recurring"
    }, {
      path: "transactional",
      component: _6fb55d9d,
      name: "fees-index-transactional"
    }]
  }, {
    path: "/fin-channels",
    component: _768f1af0,
    name: "fin-channels"
  }, {
    path: "/forex-requests",
    component: _f3ec882a,
    name: "forex-requests"
  }, {
    path: "/forex-setup",
    component: _1a45aacc,
    name: "forex-setup",
    children: [{
      path: "limits",
      component: _3c05ed2a,
      name: "forex-setup-index-limits"
    }, {
      path: "rates",
      component: _219072e0,
      name: "forex-setup-index-rates"
    }]
  }, {
    path: "/logout",
    component: _27b15386,
    name: "logout"
  }, {
    path: "/notifications",
    component: _e2398a70,
    name: "notifications"
  }, {
    path: "/payment-orders",
    component: _7fec6882,
    name: "payment-orders"
  }, {
    path: "/payments",
    component: _23f6ba23,
    name: "payments"
  }, {
    path: "/rates",
    component: _87411e9a,
    name: "rates"
  }, {
    path: "/referral-campaigns",
    component: _54d814e9,
    name: "referral-campaigns"
  }, {
    path: "/referrals",
    component: _398a2f56,
    name: "referrals"
  }, {
    path: "/savings-setup",
    component: _1b530509,
    name: "savings-setup",
    children: [{
      path: "deposits",
      component: _014ea7ea,
      name: "savings-setup-index-deposits"
    }, {
      path: "savings-account",
      component: _6f23bb13,
      name: "savings-setup-index-savings-account"
    }]
  }, {
    path: "/subscription-setup",
    component: _25965b03,
    name: "subscription-setup"
  }, {
    path: "/swift-message-orders",
    component: _5070e2db,
    name: "swift-message-orders"
  }, {
    path: "/swift-messages",
    component: _66982b3c,
    name: "swift-messages"
  }, {
    path: "/target2-participants",
    component: _145cf63c,
    name: "target2-participants"
  }, {
    path: "/users",
    component: _15e1e0e8,
    name: "users"
  }, {
    path: "/working-days",
    component: _3c65c369,
    name: "working-days"
  }, {
    path: "/banners/create",
    component: _4b1e7412,
    name: "banners-create"
  }, {
    path: "/card-orders/create",
    component: _4db8bc1c,
    name: "card-orders-create"
  }, {
    path: "/client-requests/create",
    component: _6089c0d8,
    name: "client-requests-create"
  }, {
    path: "/czcb-swifts/upload",
    component: _256c7c6c,
    name: "czcb-swifts-upload"
  }, {
    path: "/fees/groups",
    component: _766a0216,
    name: "fees-groups"
  }, {
    path: "/notifications/upload",
    component: _151ecb7b,
    name: "notifications-upload"
  }, {
    path: "/open-banking/applications",
    component: _4e0067a8,
    name: "open-banking-applications"
  }, {
    path: "/open-banking/institutions",
    component: _44762cc4,
    name: "open-banking-institutions"
  }, {
    path: "/open-banking/payments",
    component: _187bc1b6,
    name: "open-banking-payments"
  }, {
    path: "/payments/errors",
    component: _39de42ed,
    name: "payments-errors"
  }, {
    path: "/payments/not-settled",
    component: _61afc213,
    name: "payments-not-settled"
  }, {
    path: "/payments/on-hold",
    component: _e31164fe,
    name: "payments-on-hold"
  }, {
    path: "/payments/on-hold-integrator",
    component: _7b67fb0e,
    name: "payments-on-hold-integrator"
  }, {
    path: "/payments/pending",
    component: _713e6eab,
    name: "payments-pending"
  }, {
    path: "/payments/pending-cancellation",
    component: _67c77b3b,
    name: "payments-pending-cancellation"
  }, {
    path: "/payments/postponed-swift",
    component: _2a7f45e8,
    name: "payments-postponed-swift"
  }, {
    path: "/payments/unassigned",
    component: _5ba81069,
    name: "payments-unassigned"
  }, {
    path: "/payments/unidentified-topups",
    component: _566395e0,
    name: "payments-unidentified-topups"
  }, {
    path: "/payments/verification",
    component: _5c76d746,
    name: "payments-verification"
  }, {
    path: "/profile-customers/create",
    component: _0044978d,
    name: "profile-customers-create"
  }, {
    path: "/profile-customers/import",
    component: _2d54edb6,
    name: "profile-customers-import"
  }, {
    path: "/profiles/legal",
    component: _1ead3d07,
    name: "profiles-legal"
  }, {
    path: "/profiles/private",
    component: _7bbf555e,
    name: "profiles-private"
  }, {
    path: "/profiles/remittance",
    component: _fe024680,
    name: "profiles-remittance"
  }, {
    path: "/referral-campaigns/create",
    component: _6dded2f5,
    name: "referral-campaigns-create"
  }, {
    path: "/swift-message-orders/create",
    component: _3540797a,
    name: "swift-message-orders-create"
  }, {
    path: "/target2-participants/upload",
    component: _e80c76be,
    name: "target2-participants-upload"
  }, {
    path: "/fees/groups/create",
    component: _faea382a,
    name: "fees-groups-create"
  }, {
    path: "/fees/recurring/create",
    component: _42457b70,
    name: "fees-recurring-create"
  }, {
    path: "/fees/transactional/create",
    component: _a026a678,
    name: "fees-transactional-create"
  }, {
    path: "/payments/create/fee",
    component: _3c99ec16,
    name: "payments-create-fee"
  }, {
    path: "/payments/create/forex",
    component: _3350f92b,
    name: "payments-create-forex"
  }, {
    path: "/payments/create/internal",
    component: _368b8344,
    name: "payments-create-internal"
  }, {
    path: "/payments/create/topup",
    component: _143f7b9f,
    name: "payments-create-topup"
  }, {
    path: "/payments/create/withdrawal",
    component: _d68f2f88,
    name: "payments-create-withdrawal"
  }, {
    path: "/",
    component: _64c46fef,
    name: "index"
  }, {
    path: "/channel-setup/channel-route/:channelRouteId",
    component: _3cb6d7d8,
    name: "channel-setup-channel-route-channelRouteId"
  }, {
    path: "/fees/groups/:id",
    component: _74afbbfe,
    name: "fees-groups-id"
  }, {
    path: "/fees/recurring/:recurringFeeId",
    component: _e57adcb6,
    name: "fees-recurring-recurringFeeId"
  }, {
    path: "/fees/transactional/:transactionFeeId",
    component: _c32067a0,
    name: "fees-transactional-transactionFeeId"
  }, {
    path: "/channel-setup/channel-route/:channelRouteId?/edit",
    component: _0d6abcb8,
    name: "channel-setup-channel-route-channelRouteId-edit"
  }, {
    path: "/fees/groups/:id/edit",
    component: _4a1185aa,
    name: "fees-groups-id-edit"
  }, {
    path: "/fees/recurring/:recurringFeeId?/edit",
    component: _7a88a36c,
    name: "fees-recurring-recurringFeeId-edit"
  }, {
    path: "/fees/transactional/:transactionFeeId?/edit",
    component: _4bf4529f,
    name: "fees-transactional-transactionFeeId-edit"
  }, {
    path: "/card-orders/:orderId",
    component: _6d11e626,
    name: "card-orders-orderId"
  }, {
    path: "/channel-setup/:license",
    component: _6d59ced4,
    name: "channel-setup-license"
  }, {
    path: "/client-requests/:clientRequestId",
    component: _b428f6c2,
    name: "client-requests-clientRequestId"
  }, {
    path: "/custom-requests/:requestId",
    component: _cc2d8960,
    name: "custom-requests-requestId"
  }, {
    path: "/deposits/:depositId?",
    component: _1dcaae1e,
    name: "deposits-depositId"
  }, {
    path: "/payment-orders/:paymentOrderId",
    component: _e247ae16,
    name: "payment-orders-paymentOrderId"
  }, {
    path: "/payments/:paymentId",
    component: _4d0e3c7e,
    name: "payments-paymentId",
    children: [{
      path: "activity",
      component: _5b7886cd,
      name: "payments-paymentId-activity"
    }, {
      path: "general",
      component: _44a75a1a,
      name: "payments-paymentId-general"
    }, {
      path: "operations",
      component: _4df1b8ac,
      name: "payments-paymentId-operations"
    }]
  }, {
    path: "/profile-customers/:customerId",
    component: _11728e8c,
    name: "profile-customers-customerId"
  }, {
    path: "/profiles/:profileId?",
    component: _543264c7,
    name: "profiles-profileId",
    children: [{
      path: "accounts",
      component: _107e8fde,
      name: "profiles-profileId-accounts"
    }, {
      path: "activity",
      component: _2f7b0a87,
      name: "profiles-profileId-activity"
    }, {
      path: "card-orders",
      component: _38db217a,
      name: "profiles-profileId-card-orders"
    }, {
      path: "card-topup",
      component: _76f25f2b,
      name: "profiles-profileId-card-topup"
    }, {
      path: "cards",
      component: _2b2e081b,
      name: "profiles-profileId-cards"
    }, {
      path: "cashback",
      component: _ac13eedc,
      name: "profiles-profileId-cashback"
    }, {
      path: "customers",
      component: _fce1f7e6,
      name: "profiles-profileId-customers"
    }, {
      path: "esim-reissue",
      component: _e28cb8fa,
      name: "profiles-profileId-esim-reissue"
    }, {
      path: "features",
      component: _1783b4b5,
      name: "profiles-profileId-features"
    }, {
      path: "fees",
      component: _4179ae25,
      name: "profiles-profileId-fees"
    }, {
      path: "forex-setup",
      component: _66e898e4,
      name: "profiles-profileId-forex-setup"
    }, {
      path: "open-banking",
      component: _21edb51b,
      name: "profiles-profileId-open-banking"
    }, {
      path: "payment-orders",
      component: _0af7b184,
      name: "profiles-profileId-payment-orders"
    }, {
      path: "payments",
      component: _9c5c30b6,
      name: "profiles-profileId-payments"
    }, {
      path: "requests",
      component: _1d1f14bc,
      name: "profiles-profileId-requests"
    }, {
      path: "restrictions",
      component: _5df5fcc2,
      name: "profiles-profileId-restrictions"
    }, {
      path: "savings",
      component: _170a0a71,
      name: "profiles-profileId-savings"
    }, {
      path: "settings",
      component: _2381acca,
      name: "profiles-profileId-settings"
    }, {
      path: "users",
      component: _4e05d440,
      name: "profiles-profileId-users"
    }, {
      path: "watchdog",
      component: _7505c285,
      name: "profiles-profileId-watchdog"
    }]
  }, {
    path: "/referral-campaigns/:campaignId",
    component: _539a1284,
    name: "referral-campaigns-campaignId"
  }, {
    path: "/savings-accounts/:savingsAccountId?",
    component: _5abe082c,
    name: "savings-accounts-savingsAccountId",
    children: [{
      path: "general",
      component: _5bfe34f6,
      name: "savings-accounts-savingsAccountId-general"
    }, {
      path: "transactions",
      component: _d936b2f0,
      name: "savings-accounts-savingsAccountId-transactions"
    }]
  }, {
    path: "/swift-message-orders/:swiftMessageOrderId",
    component: _30e48600,
    name: "swift-message-orders-swiftMessageOrderId"
  }, {
    path: "/swift-messages/:messageCloudReference",
    component: _2a3e6e07,
    name: "swift-messages-messageCloudReference"
  }, {
    path: "/banners/:bannerId/edit",
    component: _fa7f6ba4,
    name: "banners-bannerId-edit"
  }, {
    path: "/card-orders/:orderId?/card",
    component: _75234276,
    name: "card-orders-orderId-card",
    children: [{
      path: "activity",
      component: _7ef5236e,
      name: "card-orders-orderId-card-activity"
    }, {
      path: "data",
      component: _6a800664,
      name: "card-orders-orderId-card-data"
    }, {
      path: "delivery",
      component: _efd4c6a4,
      name: "card-orders-orderId-card-delivery"
    }, {
      path: "limits",
      component: _56399b52,
      name: "card-orders-orderId-card-limits"
    }]
  }, {
    path: "/card-orders/:orderId?/edit",
    component: _256944bf,
    name: "card-orders-orderId-edit"
  }, {
    path: "/channel-setup/:license?/create",
    component: _6594566a,
    name: "channel-setup-license-create"
  }, {
    path: "/profile-customers/:customerId?/edit",
    component: _db83295c,
    name: "profile-customers-customerId-edit"
  }, {
    path: "/profile-customers/:customerId?/view",
    component: _7a08726d,
    children: [{
      path: "",
      component: _178299a0,
      name: "profile-customers-customerId-view"
    }, {
      path: "activity",
      component: _5cc2f7a1,
      name: "profile-customers-customerId-view-activity"
    }, {
      path: "general",
      component: _02a17ec6,
      name: "profile-customers-customerId-view-general"
    }]
  }, {
    path: "/referral-campaigns/:campaignId?/edit",
    component: _0093b048,
    name: "referral-campaigns-campaignId-edit"
  }, {
    path: "/swift-messages/:swiftMessageId?/reply",
    component: _1d249953,
    name: "swift-messages-swiftMessageId-reply"
  }, {
    path: "/swift-messages/:swiftMessageId?/v2",
    component: _a67297b4,
    name: "swift-messages-swiftMessageId-v2"
  }, {
    path: "/channel-setup/:license?/:currency",
    component: _97aaa716,
    name: "channel-setup-license-currency",
    children: [{
      path: "activity",
      component: _a264f2ce,
      name: "channel-setup-license-currency-index-activity"
    }, {
      path: "settings",
      component: _6d91a5ad,
      name: "channel-setup-license-currency-index-settings"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
